<template>
  <v-card>
    <v-data-iterator class="mt-5" :items="records" :page="current_page" :items-per-page="50">
      <template v-slot:header>
        <v-toolbar flat color="white" density="compact">
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              density="compact"
              v-model="advanced_search.cluster"
              :items="advanced_search_models.cluster"
              @update:model-value="showRecords"
              :return-object="false"
              hide-details
              single-line
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('cluster') }}</span>
            </template>
          </v-autocomplete>
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              density="compact"
              v-model="advanced_search.unit"
              :items="advanced_search_models.unit"
              @update:model-value="showRecords"
              :return-object="false"
              hide-details
              single-line
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('unit') }}</span>
            </template>
          </v-autocomplete>
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              density="compact"
              v-model="advanced_search.root_asset_name"
              :items="advanced_search_models.root_asset_name"
              @update:model-value="showRecords"
              :return-object="false"
              hide-details
              single-line
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('root_asset_name') }}</span>
            </template>
          </v-autocomplete>
          <v-spacer/>
        </v-toolbar>
        <v-toolbar flat color="white" density="compact">
          <v-btn-toggle v-model="advanced_search.sece" class="ml-5" density="compact" mandatory base-color="white" color="primary" rounded="xl" border @update:model-value="showRecords">
            <v-btn value="sece">
              {{ $store.getters.translate('sece') }}
            </v-btn>
            <v-btn value="non_sece">
              {{ $store.getters.translate('non_sece') }}
            </v-btn>
            <v-btn value="all">
              {{ $store.getters.translate('all') }}
            </v-btn>
          </v-btn-toggle>
          <v-text-field
              density="compact"
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              color="primary"
              v-model="advanced_search.text_search"
              v-debounce:800ms.lock="showRecords"
              @click:clear="clearSearch('text_search')"
              hide-details
              single-line
              flat
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('search') }}</span>
            </template>
          </v-text-field>
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              density="compact"
              v-model="advanced_search.priority"
              :items="['Prior 0','Prior 1','Prior 2','Prior 3']"
              @update:model-value="showRecords"
              hide-details
              single-line
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('priority') }}</span>
            </template>
          </v-autocomplete>
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              density="compact"
              v-model="advanced_search.company_priority"
              :items="['Critical','High','Medium','Low']"
              @update:model-value="showRecords"
              hide-details
              single-line
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('company_priority') }}</span>
            </template>
          </v-autocomplete>
          <v-spacer/>
          <v-menu>
            <template #activator="{ props }">
              <v-btn elevation="0" icon v-bind="props">
                <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="hide_closed_defects" @click="setClosedState(false)">
                <template #prepend><PhEye size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">
                  <span>{{ $store.getters.translate('show_closed') }}</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-else @click="setClosedState(true)">
                <template #prepend><PhEyeSlash size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">
                  <span>{{ $store.getters.translate('hide_closed') }}</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </template>
      <template v-slot:default="{ items, isExpanded, toggleExpand }">
        <template v-for="(item, index) in items" :key="index">
          <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
            <v-row>
              <v-col cols="11">
                <v-row class="rounded-xl" style="background-color: #faebec; align-items: center; cursor: pointer;" @click.stop="$emit('edit', item.raw)">
                  <v-col class="ml-3">
                    <span class="sm-bold">{{ $store.getters.translate('id') + ': ' }}</span>
                    <span class="sm-normal">{{ item.raw.id }}</span>
                  </v-col>
                  <v-col>
                    <span class="sm-bold">{{ $store.getters.translate('defect_status') + ':' }}</span>
                    <template v-if="item.raw.closed">
                      <v-icon color="green" size="8" class="ml-2 mr-2">mdi-circle</v-icon>
                      <span class="sm-normal">Ready</span>
                    </template>
                    <template v-else>
                      <v-icon color="red" size="8" class="ml-2 mr-2">mdi-circle</v-icon>
                      <span class="sm-normal">Not Ready</span>
                    </template>
                  </v-col>
                  <v-col class="pa-0">
                    <span class="sm-bold" style="float: left; display: block; height: 36px; align-content: center;">{{ $store.getters.translate('priority') + ':' }}</span>
                    <PhNumberCircleZero v-if="item.raw.priority === 'Prior 0'" color="red" size="36" class="ml-2"/>
                    <PhNumberCircleOne v-else-if="item.raw.priority === 'Prior 1'" color="red" size="36" class="ml-2"/>
                    <PhNumberCircleTwo v-else-if="item.raw.priority === 'Prior 2'" color="orange" size="36" class="ml-2"/>
                    <PhNumberCircleThree v-else-if="item.raw.priority === 'Prior 3'" color="orange" size="36" class="ml-2"/>
                    <span v-else class="sm-normal pl-1" style="display: block; height: 36px; align-content: center;">Not set</span>
                  </v-col>
                  <v-col>
                    <span class="sm-bold">{{ $store.getters.translate('company_priority') + ': ' }}</span>
                    <span class="sm-normal">{{ item.raw.company_priority }}</span>
                  </v-col>
                  <v-col>
                    <span class="sm-bold">{{ $store.getters.translate('cluster') + ': ' }}</span>
                    <span class="sm-normal">{{ item.raw.cluster }}</span>
                  </v-col>
                  <v-col>
                    <span class="sm-bold">{{ $store.getters.translate('inspection') + ': ' }}</span>
                    <span class="sm-normal">{{ item.raw.inspection_name }}</span>
                  </v-col>
                </v-row>
                <v-row class="mb-0">
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('section') }}</div>
                    <div class="sm-normal">{{ $store.getters.translate(item.raw.distribution_device_function_name) }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('category') }}</div>
                    <div class="sm-normal">{{ $store.getters.translate(item.raw.deficiency_group) }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('distribution_panel_name') }}</div>
                    <div class="sm-normal">{{ item.raw.distribution_panel_name }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('circuit_number') }}</div>
                    <div class="sm-normal">{{ item.raw.circuit_number }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('tag_number_name') }}</div>
                    <div class="sm-normal">{{ item.raw.tag_number_name }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('description') }}</div>
                    <div class="sm-normal">{{ item.raw.description }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('location_name') }}</div>
                    <div class="sm-normal">{{ item.raw.location_name }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('root_asset_name') }}</div>
                    <div class="sm-normal">{{ item.raw.root_asset_name }}</div>
                  </v-col>
                </v-row>
                <v-row class="mb-0">
                  <v-col class="pa-0" style="background-color: #F6F6F6; min-height: 100px;">
                    <v-sheet color="red-darken-1" min-height="100px" width="3" class="position-absolute"/>
                    <div class="text-red-darken-1 sm-bold ml-5 mt-2">
                      {{ $store.getters.translate("deviations_and_remarks") }}
                    </div>
                    <div class="sm-normal text-primary ml-5 mt-2 mb-2">
                      {{ item.raw.deviations_and_remarks }}
                    </div>
                  </v-col>
                  <v-col class="pa-0 ml-5" style="background-color: #F6F6F6; min-height: 100px;">
<!--                <v-sheet color="orange-darken-1" min-height="100px" width="3" class="position-absolute"/>
                    <div class="text-orange-darken-1 sm-bold ml-5 mt-2">
                      {{ $store.getters.translate("remarks") }}
                    </div>
                    <div class="sm-normal text-primary ml-5 mt-2 mb-2">
                      {{ item.raw.remarks }}
                    </div>-->
                  </v-col>
                </v-row>
                <v-expand-transition>
                  <v-row v-if="isExpanded(item)">
                    <v-col>
                      <v-row>
                        <v-col>
                          <span class="sm-bold">{{ $store.getters.translate('technical_drawing') + ': ' }}</span>
                          <span class="sm-normal">{{ item.raw.drawing_number }}</span>
                          <span class="sm-normal" v-if="item.raw.page">{{ ', ' + $store.getters.translate('page') + ': ' + item.raw.page }}</span>
                        </v-col>
                        <v-col>
                          <span class="sm-bold">{{ $store.getters.translate('revision') + ': ' }}</span>
                          <span class="sm-normal">{{ item.raw.revision }}</span>
                        </v-col>
                        <v-col class="pa-0">
                          <base-link-button v-if="item.raw.article_id" @action="$router.push('/articles/' + item.raw.article_id)">
                            <template #prepend><PhArrowSquareOut style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                            {{ $store.getters.translate("view") + ' ' + $store.getters.translate("article") }}
                          </base-link-button>
                        </v-col>
                        <v-col class="pa-0">
                          <base-link-button v-if="item.raw.inspection_id" @action="$router.push('/inspections/' + item.raw.inspection_id)">
                            <template #prepend><PhArrowSquareOut style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                            {{ $store.getters.translate("view") + ' ' + $store.getters.translate("inspection") }}
                          </base-link-button>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-expand-transition>
              </v-col>
              <v-col class="pa-0 ml-3">
                <v-layout v-if="item.raw.image" align-center justify-center column fill-height>
                  <v-img :src="item.raw.image" class="ma-auto"/>
                </v-layout>
                <base-link-button class="mt-3 pa-2" v-if="isExpanded(item)" @action="toggleExpand(item)">
                  <template #prepend><PhCaretUp style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                  {{ $store.getters.translate('view_less') }}
                </base-link-button>
                <base-link-button class="mt-3 pa-2" v-else @action="toggleExpand(item)">
                  <template #prepend><PhCaretDown style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                  {{ $store.getters.translate('view_more') }}
                </base-link-button>
              </v-col>
            </v-row>
          </v-card>
        </template>
      </template>
      <template v-slot:footer="{ pageCount }">
        <v-pagination v-model="current_page" :length="pageCount" rounded="circle"/>
      </template>
    </v-data-iterator>
  </v-card>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseLinkButton from "../../components/commonComponents/BaseLinkButton";
import { PhArrowSquareOut, PhCaretDown, PhCaretUp, PhDotsThreeVertical, PhEye, PhEyeSlash, PhNumberCircleOne, PhNumberCircleThree, PhNumberCircleTwo, PhNumberCircleZero } from "@phosphor-icons/vue";

export default {
  components: {
    BaseLinkButton,
    PhCaretUp, PhCaretDown, PhArrowSquareOut, PhNumberCircleZero, PhEyeSlash, PhEye, PhDotsThreeVertical, PhNumberCircleThree, PhNumberCircleTwo, PhNumberCircleOne,
  },
  data() {
    return {
      page: helpFunctions.pages.defects,
      all_records: [],
      records: [],
      hide_closed_defects: true,
      advanced_search: {
        text_search: null,
        cluster: null,
        unit: null,
        root_asset_name: null,
        priority: null,
        company_priority: null,
        sece: 'all',
      },
      advanced_search_models: {
        cluster: [],
        unit: [],
        root_asset_name: [],
      },
      current_page: 1
    };
  },
  methods: {
    fillAdvancedSearchArrays() {
      this.all_records.forEach(record => {
        if(record.cluster && !this.advanced_search_models.cluster.includes(record.cluster)) {
          this.advanced_search_models.cluster.push(record.cluster);
        }
        if(record.unit && !this.advanced_search_models.unit.includes(record.unit)) {
          this.advanced_search_models.unit.push(record.unit);
        }
        if(record.root_asset_name && !this.advanced_search_models.root_asset_name.includes(record.root_asset_name)) {
          this.advanced_search_models.root_asset_name.push(record.root_asset_name);
        }
      });
      this.showRecords();
    },
    showRecords() {
      let sorted_array = this.all_records;
      if(this.hide_closed_defects) {
        sorted_array = sorted_array.filter((item) => !item.closed);
      }
      if(this.advanced_search.cluster) {
        sorted_array = sorted_array.filter(item => item.cluster === this.advanced_search.cluster);
      }
      if(this.advanced_search.unit) {
        sorted_array = sorted_array.filter(item => item.unit === this.advanced_search.unit);
      }
      if(this.advanced_search.root_asset_name) {
        sorted_array = sorted_array.filter(item => item.root_asset_name === this.advanced_search.root_asset_name);
      }
      if(this.advanced_search.priority) {
        sorted_array = sorted_array.filter(item => item.priority === this.advanced_search.priority);
      }
      if(this.advanced_search.company_priority) {
        sorted_array = sorted_array.filter(item => item.company_priority === this.advanced_search.company_priority);
      }
      if(this.advanced_search.sece === 'sece') {
        sorted_array = sorted_array.filter(item => item.sece);
      }
      else if(this.advanced_search.sece === 'non_sece') {
        sorted_array = sorted_array.filter(item => !item.sece);
      }
      if(this.advanced_search.text_search) {
        sorted_array = sorted_array.filter(item => (item.distribution_device_function_name && this.$store.getters.translate(item.distribution_device_function_name).toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.deficiency_group && this.$store.getters.translate(item.deficiency_group).toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.distribution_panel_name && item.distribution_panel_name.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.tag_number_name && item.tag_number_name.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.description && item.description.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.location_name && item.location_name.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.deviations_and_remarks && item.deviations_and_remarks.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())));
      }
      this.records = sorted_array;
      this.current_page = 1;
    },
    clearSearch(key) {
      this.advanced_search[key] = null;
      this.showRecords();
    },
    setClosedState(new_state) {
      this.hide_closed_defects = new_state;
      this.showRecords();
    },
  },
};
</script>